define('shoptheme/components/ui/datatables',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"datatables",
	"datatables-sort-de"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({

		$init: function() {
			var blocks = BEM.block('sortable-table'),
				_self = this;

			blocks.each(function(){
				var table = $($(this).find('table').get(0));

				var itemCount = table.find('tr').length,
					itemMax = table.data('page-min-items');

				var paginate = false;

				if (itemCount-1 > itemMax-1) {
					paginate = true;
				}

				_self.dataTables(table, paginate);
			});
		},

		dataTables: function(table, paginate) {
			table.DataTable({
				searching: false,
				lengthChange: false,
				responsive: true,
				'info' : false,
				'order': [
					[ 2, "desc" ]
				],
				'columnDefs': [
					{ "orderable": false, "targets": 0 },
					{ "type": "de_date", "targets": 2 },
					{ "orderable": false, "targets": 3 }
				],
				"paging": paginate,
				"info": false
			});
		}



	});
});
